import { render, staticRenderFns } from "./savingspermember.vue?vue&type=template&id=4c5da28a"
import script from "./savingspermember.vue?vue&type=script&lang=js"
export * from "./savingspermember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports